<template>
  <Teleport to="body">
    <div id="n-anchor" />
  </Teleport>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
window.nitroAds.createAd('n-anchor', {
  refreshLimit: 20,
  refreshTime: 30,
  format: 'anchor',
  anchor: 'bottom',
  anchorPersistClose: true,
  report: {
    enabled: false,
  },
  mediaQuery: '(min-width: 320px) and (max-width: 767px)',
});
</script>
